import { combineReducers } from "redux";

import appReducer from "./app/reducer";
import applicationsReducer from "./applications/reducer";
import sessionReducer from "./session/reducer";
import shortcutsReducer from "./shortcuts/reducer";
import ticketActivityReducer from "./ticket-activity/reducer";
import toastReducer from "./toasts/reducer";

const featuresReducer = combineReducers({
  app: appReducer,
  applications: applicationsReducer,
  toast: toastReducer,
  session: sessionReducer,
  shortcuts: shortcutsReducer,
  ticketActivity: ticketActivityReducer,
});

export type FeaturesState = ReturnType<typeof featuresReducer>;

export default featuresReducer;
